export default __webpack_public_path__ + "static/media/n_wdt_c_1.4c73e7df.mp3";